import { createSlice } from '@reduxjs/toolkit';
import { initialState, commonReducers } from './fileVersionHistory.slice';

const priceMatrixVersionHistorySlice = createSlice({
  name: 'priceMatrixVersionHistory',
  initialState,
  reducers: { ...commonReducers },
});

export default priceMatrixVersionHistorySlice.reducer;
export const {
  setOpenFileVersionHistory,
  setOpenDeleteVersionConfirmationModal,
  addToFileVersions,
  getNextVersions,
  deletedLastVersion,
} = priceMatrixVersionHistorySlice.actions;
